import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/choose-challenge-type.png'


const _withScopeId = n => (_pushScopeId("data-v-cff8c032"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-campaign-cocacola-season-5"
}
const _hoisted_2 = { class: "d-block d-sm-none mobile-navbar" }
const _hoisted_3 = { class: "mobile-tabs font-Pretendar" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-none d-md-block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "scroll-page" }, null, -1))
const _hoisted_7 = { class: "d-none d-md-block" }
const _hoisted_8 = { class: "chooseChallenge font-Pretendar" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center cola-color fw-bold" }, " 챌린지 선택하기 ", -1))
const _hoisted_10 = { class: "d-flex w-100 gap-5 mt-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "챌린지 선택",
  class: "w-100 mt-3"
}, null, -1))
const _hoisted_12 = { class: "footer-btn-group" }
const _hoisted_13 = { class: "ss6-footer" }

import PageMain from './components/page-main.vue';
import Navbar from './components/navbar.vue';
import CheckPopups, { type CheckExpose } from './components/popups/check.vue';
import QuizPoupups, { type QuizeExpose } from './components/popups/quiz.vue';
import ParticipatePopups, { type ParticipateExpose } from './components/popups/participate.vue';
import CollectPopups, { type CollectExpose } from './components/popups/collect.vue';
import Participate from './components/participate.vue';
import PopupError from './components/popups/popup-error.vue';
import NoticePopup from './components/popups/notice.vue';
import EveryoneChallenge from './components/everyone-challenge.vue';
import HeroSection from './components/hero-section.vue';
import SscolaFooter from './components/sscola-footer.vue';
import CampusChallenge from './components/campus-challenge.vue';
import CautionPage from './components/caution-page.vue';
import PopupChooseChallangeType from './components/popups/popup-choose-challange-type.vue';
import EveryoneCollectPage from './components/everyone-collect-page.vue';
import CampusCollectPage from './components/campus-collect-page.vue';
import { Challenge } from '@/templates/campaign-cocacola-season-6/components/model/challenge';

import { computed, inject, nextTick, onMounted, onUnmounted, provide, reactive, ref, Ref, toRef, watch } from 'vue';
import { useElementBounding, useScroll } from '@vueuse/core';
import { useRoute } from 'vue-router';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import _ from 'lodash';
import 'swiper/css';
import 'swiper/css/pagination';

import { IProgram } from '@/types/program';
import { getImages } from './static';
import { request } from '@/utils';
import { authStore } from '@/stores';
import router from '@/router';

// === CONSTANTS ===
interface IProps {
  program: IProgram;
}

interface MenuType {
  name: string;
  key?: 'main' | 'mission' | 'date' | 'method' | 'faq' | 'everyone-challenge' | 'cautionRef' | 'apply';
  pageRef?: Ref<HTMLDivElement | undefined>;
  anchor?: string;
  section?: string;
  onClick?: () => Promise<void> | void;
  disabled?: boolean;
}

// === DAYJS SETUP ===

export default /*#__PURE__*/_defineComponent({
  props: {
    program: { default: () => ({} as IProgram) }
  },
  setup(__props: any) {

const props = __props as { program: IProgram }

// === IMPORTS ===
const PROGRAM_FIXED_ID = (process.env.VUE_APP_ENV !== 'development') ? {
  everyone_program_round1: 232,
  everyone_program_round2: 233,
  campus: 77,
  everyone_round2_internal: 76
} as const : {
  everyone_program_round1: 232,
  everyone_program_round2: 233,
  campus: 8,
  everyone_round2_internal: 10
} as const;

const NOTICE_POPUP_CUTOFF_DATE = '2024-07-31T20:00:00.000+09:00';

const DATES = {
  EVERYONE_ROUND1_ANNOUNCEMENT: '2025-07-15T10:00:00.000+09:00',
  EVERYONE_ROUND1_BOX_DELIVERY: '2025-07-15T10:00:00.000+09:00',
  EVERYONE_ROUND2_ANNOUNCEMENT: '2025-08-15T10:00:00.000+09:00',
  EVERYONE_ROUND2_BOX_DELIVERY: '2025-08-15T10:00:00.000+09:00'
} as const;

const CHALLENGE_SUBTITLES = {
  CAMPUS: '대학생들이 참여하는',
  EVERYONE: '누구나 참여하는 모두의 챌린지'
} as const;

const ERROR_MESSAGES = {
  COLLECTION_COMPLETED: `수령하신 제로 웨이스트 박스
  모두 수거 신청 완료되었습니다.`
} as const;

const VALID_SECTIONS = ['modu', 'campus', 'caution'] as const;

const SECTION_MAPPING = {
  everyone: 'modu',
  campus: 'campus',
  caution: 'caution'
} as const;

const MENU_NAMES = {
  MAIN: '원더플 시즌6',
  EVERYONE_CHALLENGE: '모두의 챌린지',
  CAMPUS_CHALLENGE: '캠퍼스 챌린지',
  CAUTION: '주의사항',
  APPLY: '참여신청하기'
} as const;

const SCROLL_OFFSET = 70;
const CAMPUS_ANNOUNCEMENT_OFFSET_DAYS = 2;
const CAMPUS_BOX_DELIVERY_OFFSET_DAYS = 5;
const ANCHOR_SCROLL_DELAY = 300;

const WEBP_TEST_DATA_URI = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';

// === INTERFACES ===
dayjs.extend(isBetween);

// === PROPS ===


// === REFS AND REACTIVE STATE ===
const programStepData = ref({ isCampusCollectSuccess: props.program.collection_count > 0, programId: props.program.id });
const navbarIsVisible = ref(true);
const isStartParticipate = ref(false);
const challengeType = ref<'everyone' | 'campus'>('everyone');
const isStartCollect = ref(false);
const errMsg = ref('');
const supportWebp = ref<boolean | undefined>();
const pageInited = ref(false);
const currentSection = ref<string>('main');

const popupVisible = reactive({
  error: false,
  chooseChallenge: false,
});

// Element refs
const pageMainRef = ref<HTMLDivElement>();
const everyoneChallengeRef = ref<HTMLDivElement>();
const campusChallengeRef = ref<HTMLDivElement>();
const cautionRef = ref<HTMLDivElement>();
const navContainer = ref<HTMLDivElement>();

// Component refs
const checkPopupsRef = ref<CheckExpose>();
const quizPopupsRef = ref<QuizeExpose>();
const participatePopupsRef = ref<ParticipateExpose>();
const collectPopupsRef = ref<CollectExpose>();

// === INJECTIONS AND PROVIDES ===
const refreshPageData = inject<Function>('refreshPageData') || _.noop;
const route = useRoute();

provide('program', toRef(props, 'program'));
provide('programStepData', programStepData);
provide('everyone_round1_progId', PROGRAM_FIXED_ID.everyone_program_round1);
provide('everyone_round2_progId', PROGRAM_FIXED_ID.everyone_program_round2);

// === UTILITY FUNCTIONS ===
async function fetchCampusCollectionStatus() {
  try {
    // Fetch user's collection requests for campus program
    const { data } = await request.get('/additional_box_requests', {
      params: {
        program_id_eq: props.program.id,
        page: 0,
        perpage: 100,
        offset: 0
      },
            loading: { silent: true }
    });

    // Check if user has any successful campus collection requests
    if (data && data.length > 0) {
      await nextTick();
    }
  } catch (error) {
    // Keep default value (false) on error
  }
}
function checkWebPSupport(): Promise<boolean> {
  return new Promise((resolve) => {
    const image = new Image();
    image.addEventListener('error', () => resolve(false));
    image.addEventListener('load', () => resolve(image.width > 0 && image.height > 0));
    image.src = WEBP_TEST_DATA_URI;
  });
}

function addDate(date: Date, days: number): Date {
  date.setDate(date.getDate() + days);
  return date;
}

// === POPUP FUNCTIONS ===
function hidePopup(key?: keyof typeof popupVisible) {
  if (key) {
    popupVisible[key] = false;
  } else {
    Object.keys(popupVisible).forEach((k) => {
      const popupKey = k as keyof typeof popupVisible;
      if (popupVisible[popupKey]) {
        popupVisible[popupKey] = false;
      }
    });
  }
}

async function showPopup(key: keyof typeof popupVisible) {
  hidePopup();
  await nextTick();
  popupVisible[key] = true;
}

const handleShowError = (message: string) => {
  errMsg.value = message;
  showPopup('error');
};

// === NAVIGATION FUNCTIONS ===
function updateUrl(section: string) {
  const pathSegments = route.path.split('/');
  const baseSegments = pathSegments.slice(0, 3);
  let newPath = `${baseSegments.join('/')}`;

  if (section !== 'main') {
    newPath += `/${section}`;
  }

  if (!newPath.startsWith('/')) {
    newPath = '/' + newPath;
  }

  router.push(newPath);
}

const popupChooseChallange = () => {
  if (currentSection.value === 'main') {
    popupVisible.chooseChallenge = true;
  } else if (currentSection.value === 'modu') {
    participate('everyone');
  } else if (currentSection.value === 'campus') {
    participate('campus');
  } else if (currentSection.value === 'caution') {
    popupVisible.chooseChallenge = true;
  }
};

function navToPage(item: typeof menus.value[number]) {
  if (item.onClick) {
    item.onClick();
    return;
  }
  if (item.section) {
    currentSection.value = item.section;
    updateUrl(item.section);
    return;
  }
  if (item.pageRef) {
    isScrollingProgrammatically = true;
    item.pageRef?.value?.scrollIntoView({ block: 'start' });
  }
}

function navToPageByKey(key: MenuType['key']) {
  const item = menus.value.find(item => item.key === key);
  if (item) {
    navToPage(item);
  }
}

function onMenuItemClick(item: { name: string; disabled?: boolean; key?: string }) {
  isStartCollect.value = false;
  isStartParticipate.value = false;
  const menuItem = menus.value.find(menu => menu.name === item.name);
  if (menuItem) {
    navToPage(menuItem);
  }
}

function scrollToAnchorPosition() {
  const key = route.hash.split('#page-').pop();
  if (key) {
    navToPageByKey(key as any);
  }
}

const handleNavigateFromMain = (type: string) => {
  const section = SECTION_MAPPING[type as keyof typeof SECTION_MAPPING];
  if (section) {
    currentSection.value = section;
    updateUrl(section);
  }
};

const handleBtnParticipate = (type: string) => {
  if (type === 'everyone') {
    onMenuItemClick(menus.value[1]);
    participate('everyone');
  } else if (type === 'campus') {
    onMenuItemClick(menus.value[2]);
    participate('campus');
  }
  hidePopup();
};

// === MAIN BUSINESS LOGIC ===
async function participate(challengeTypez: 'everyone' | 'campus') {
  const valid = await checkPopupsRef.value?.start();

  if (valid) {
    await refreshPageData();
    await nextTick();

    if (challengeTypez === 'campus') {
      const { show_participate_btn, participate_btn_msg } = props.program || {};
      if (!show_participate_btn) {
        errMsg.value = participate_btn_msg || '';
        showPopup('error');
        return;
      }
    }

    challengeType.value = challengeTypez;
    isStartParticipate.value = true;
  }
}

async function collect(challengeTypez: 'everyone' | 'campus', programz?: any) {

  const valid = await checkPopupsRef.value?.start();
  if (!programz) { await refreshPageData(); }
  programz = programz || props.program;
  if (valid) {
    await nextTick();
    const {
      show_collection_btn,
      collection_count = 0,
      collection_challenge = 0,
      collection_btn_msg
    } = programz || {};
    if (show_collection_btn) {
      if (collection_count >= collection_challenge && challengeTypez !== 'campus') {
        errMsg.value = ERROR_MESSAGES.COLLECTION_COMPLETED;
        showPopup('error');
        return;
      }
      challengeType.value = challengeTypez;
      isStartCollect.value = true;
      isStartParticipate.value = false;
      return;
    }
    errMsg.value = collection_btn_msg || '';
    showPopup('error');
  }
}

function onQuizeDone() {
  participatePopupsRef.value?.start();
}

// === COMPUTED PROPERTIES ===
const s5Images = computed(() => getImages(supportWebp.value));

const rounds = computed(() => props.program.program_rounds || []);

const menus = computed<Array<MenuType>>(() => {
  return [
    {
      name: MENU_NAMES.MAIN,
      key: 'main',
      section: 'main',
      pageRef: pageMainRef,
      anchor: '#page-main',
    },
    {
      name: MENU_NAMES.EVERYONE_CHALLENGE,
      key: 'everyone-challenge',
      section: 'modu',
      pageRef: everyoneChallengeRef,
      anchor: '#page-everyone-challenge',
    },
    {
      name: MENU_NAMES.CAMPUS_CHALLENGE,
      key: 'date',
      section: 'campus',
      pageRef: campusChallengeRef,
      anchor: '#campusChallenge',
    },
    {
      name: MENU_NAMES.CAUTION,
      key: 'cautionRef',
      section: 'caution',
      pageRef: cautionRef,
      anchor: '#page-caution',
    },
    {
      name: MENU_NAMES.APPLY,
      key: 'apply',
      onClick: popupChooseChallange,
    }
  ];
});

const activeMenuIndex = computed(() => {
  return menus.value.findIndex(menu => menu.section === currentSection.value);
});

const campusChallenge = computed((): Challenge => {
  const campusOrigin = rounds.value.find(item => item.id === PROGRAM_FIXED_ID.campus);
  if (!campusOrigin) {

  }

  return {
    id: campusOrigin?.id,
    subtitle: CHALLENGE_SUBTITLES.CAMPUS,
    title: campusOrigin?.title,
    recruitmentFrom: new Date(campusOrigin?.participate_started_at || ''),
    recruitmentTo: new Date(campusOrigin?.participate_ended_at || ''),
    collectionFrom: new Date(campusOrigin?.collection_started_at || ''),
    collectionTo: new Date(campusOrigin?.collection_ended_at || ''),
    participantAnnouncement: addDate(new Date(campusOrigin?.participate_ended_at || ''), CAMPUS_ANNOUNCEMENT_OFFSET_DAYS),
    boxDelivery: addDate(new Date(campusOrigin?.participate_ended_at || ''), CAMPUS_BOX_DELIVERY_OFFSET_DAYS),
    programId: props.program.id
  };
});

const everyoneChallenges = computed((): Challenge[] => {
  const challenges = rounds.value.filter(item => item.id !== PROGRAM_FIXED_ID.campus).map(
    round => ({
      id: round.id,
      subtitle: CHALLENGE_SUBTITLES.EVERYONE,
      title: round.title,
      recruitmentFrom: new Date(round.participate_started_at),
      recruitmentTo: new Date(round.participate_ended_at),
      collectionFrom: new Date(round.collection_started_at),
      collectionTo: new Date(round.collection_ended_at),
      participantAnnouncement: round.id === PROGRAM_FIXED_ID.everyone_round2_internal
        ? new Date(DATES.EVERYONE_ROUND2_ANNOUNCEMENT)
        : new Date(DATES.EVERYONE_ROUND1_ANNOUNCEMENT),
      boxDelivery: round.id === PROGRAM_FIXED_ID.everyone_round2_internal
        ? new Date(DATES.EVERYONE_ROUND2_BOX_DELIVERY)
        : new Date(DATES.EVERYONE_ROUND1_BOX_DELIVERY),
      programId: 0
    })
  );

  if (challenges.length >= 1) {
    challenges[0].programId = PROGRAM_FIXED_ID.everyone_program_round1;
  }
  if (challenges.length >= 2) {
    challenges[1].programId = PROGRAM_FIXED_ID.everyone_program_round2;
  }

  return challenges;
});

const activeChallenge = computed(() => {
  const now = new Date();
  return everyoneChallenges.value?.find(challenge => {
    return challenge.collectionFrom && challenge.collectionTo &&
           now >= challenge.collectionFrom && now <= challenge.collectionTo;
  });
});

const showNoticePopup = ref(dayjs().isBefore(NOTICE_POPUP_CUTOFF_DATE, 'millisecond'));

// === SCROLL HANDLING ===
let isScrollingProgrammatically = false;
const { top, height } = useElementBounding(navContainer);
const targetIsVisible = computed(() => {
  const tcHeaderHeight = parseInt(document.body.style.getPropertyValue('--tc-header-height')) || 0;
  return (top.value - tcHeaderHeight) + height.value > 0;
});

useScroll(window, {
  onScroll() {
    if (isScrollingProgrammatically) {
      return;
    }
  },
  onStop() {
    isScrollingProgrammatically = false;
  },
});

// === WATCHERS ===
watch(
  () => targetIsVisible.value,
  (val) => {
    navbarIsVisible.value = val;
  },
  { immediate: true }
);

watch(
  () => currentSection.value,
  () => {
    nextTick(() => {
      const scrollTarget = document.getElementById('scroll-page');

      if (scrollTarget) {
        const elementTop = scrollTarget.offsetTop;
        const scrollPosition = elementTop - SCROLL_OFFSET;

        window.scrollTo({
          top: Math.max(0, scrollPosition),
          behavior: 'smooth'
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
  },
  { immediate: false }
);

// === LIFECYCLE HOOKS ===
function handlePopState() {
  const childPath = route.params.section as string || '';

  if (childPath && VALID_SECTIONS.includes(childPath as any)) {
    currentSection.value = childPath;
  } else {
    currentSection.value = 'main';
  }
}

onMounted(async () => {
  const childPath = route.params.section as string || '';

  if (childPath && VALID_SECTIONS.includes(childPath as any)) {
    currentSection.value = childPath;
  } else {
    currentSection.value = 'main';
  }

  window.addEventListener('popstate', handlePopState);

  // Fetch campus collection status on mount
  if (authStore.isLogin) {
    await fetchCampusCollectionStatus();
  }
});

onUnmounted(() => {
  window.removeEventListener('popstate', handlePopState);
});

// === WEBP SUPPORT INITIALIZATION ===
checkWebPSupport()
  .then(support => supportWebp.value = support)
  .catch(() => supportWebp.value = false)
  .finally(() => nextTick(() => {
    pageInited.value = true;
    setTimeout(scrollToAnchorPosition, ANCHOR_SCROLL_DELAY);
  }));

// === PROVIDES ===
provide('participate', participate);
provide('collect', collect);
provide('navToPageByKey', navToPageByKey);
provide('images', s5Images);
provide('fetchCampusCollectionStatus', fetchCampusCollectionStatus);


return (_ctx: any,_cache: any) => {
  return (pageInited.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menus).slice(0, 4), (menu, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["mobile-tab-item", { active: _unref(activeMenuIndex) === index }]),
                onClick: ($event: any) => (onMenuItemClick(menu))
              }, _toDisplayString(menu.name), 11, _hoisted_4))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_Transition, { name: "navbar-fade" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(Navbar, {
                sticky: "",
                "active-menu-index": _unref(activeMenuIndex),
                menus: _unref(menus),
                onMenuClick: onMenuItemClick
              }, null, 8, ["active-menu-index", "menus"]), [
                [_vShow, !navbarIsVisible.value]
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode(HeroSection),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Navbar, {
            ref_key: "navContainer",
            ref: navContainer,
            sticky: false,
            "active-menu-index": _unref(activeMenuIndex),
            menus: _unref(menus),
            onMenuClick: onMenuItemClick
          }, null, 8, ["active-menu-index", "menus"])
        ]),
        (!isStartParticipate.value && !isStartCollect.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (currentSection.value === 'main')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    id: "page-main",
                    ref_key: "pageMainRef",
                    ref: pageMainRef
                  }, [
                    _createVNode(PageMain, { onNavigate: handleNavigateFromMain })
                  ], 512))
                : _createCommentVNode("", true),
              (currentSection.value === 'modu')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    id: "page-everyone-challenge",
                    ref_key: "everyoneChallengeRef",
                    ref: everyoneChallengeRef
                  }, [
                    _createVNode(EveryoneChallenge, {
                      challenges: _unref(everyoneChallenges),
                      onShowError: handleShowError
                    }, null, 8, ["challenges"])
                  ], 512))
                : _createCommentVNode("", true),
              (currentSection.value === 'campus')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    id: "campusChallenge",
                    ref_key: "campusChallengeRef",
                    ref: campusChallengeRef
                  }, [
                    _createVNode(CampusChallenge, {
                      challenges: [_unref(campusChallenge)],
                      onShowError: handleShowError
                    }, null, 8, ["challenges"])
                  ], 512))
                : _createCommentVNode("", true),
              (currentSection.value === 'caution')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    id: "cautionRef",
                    ref_key: "cautionRef",
                    ref: cautionRef
                  }, [
                    _createVNode(CautionPage)
                  ], 512))
                : _createCommentVNode("", true)
            ], 64))
          : (isStartParticipate.value && !isStartCollect.value)
            ? (_openBlock(), _createBlock(Participate, {
                key: 1,
                "challenge-type": challengeType.value,
                challenges: challengeType.value == 'everyone' ? _unref(everyoneChallenges) : [_unref(campusChallenge)],
                type: 'participate'
              }, null, 8, ["challenge-type", "challenges"]))
            : (!isStartParticipate.value && isStartCollect.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (challengeType.value=='everyone' && _unref(activeChallenge))
                    ? (_openBlock(), _createBlock(EveryoneCollectPage, {
                        key: 0,
                        challenge: _unref(activeChallenge),
                        type: "collect"
                      }, null, 8, ["challenge"]))
                    : _createCommentVNode("", true),
                  (challengeType.value=='campus')
                    ? (_openBlock(), _createBlock(CampusCollectPage, { key: 1 }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
        _createVNode(CheckPopups, {
          ref_key: "checkPopupsRef",
          ref: checkPopupsRef
        }, null, 512),
        _createVNode(QuizPoupups, {
          ref_key: "quizPopupsRef",
          ref: quizPopupsRef,
          onSuccess: onQuizeDone
        }, null, 512),
        _createVNode(ParticipatePopups, {
          ref_key: "participatePopupsRef",
          ref: participatePopupsRef
        }, null, 512),
        _createVNode(CollectPopups, {
          ref_key: "collectPopupsRef",
          ref: collectPopupsRef
        }, null, 512),
        _createVNode(PopupChooseChallangeType, {
          modelValue: _unref(popupVisible).chooseChallenge,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupVisible).chooseChallenge) = $event)),
          class: "chooseChallengeWrapper"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "btn-choose-challenge-type flex-grow-1",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {handleBtnParticipate('everyone');})
                }, " 모두의 챌린지 "),
                _createElementVNode("div", {
                  class: "btn-choose-challenge-type flex-grow-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {handleBtnParticipate('campus');})
                }, " 캠퍼스 챌린지 ")
              ]),
              _hoisted_11
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(PopupError, {
          modelValue: _unref(popupVisible).error,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(popupVisible).error) = $event)),
          title: errMsg.value
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "footer-btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (hidePopup()))
              }, " 확인했어요 ")
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        _createVNode(NoticePopup, {
          modelValue: showNoticePopup.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showNoticePopup).value = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(SscolaFooter)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})